<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search_placeholder') ||
                  '入库通知单号/入库仓库/外运单号/跟单业务/订单客户/终端客户/供应商 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>

            <el-badge
              v-if="allow('S')"
              :value="checkedCount"
              class="printer-button"
              :class="{ clearable: !!checkedCount }"
            >
              <b-button
                size="sm"
                variant="outline-primary"
                class="printer-button ml-2"
                :class="{ clearable: !!checkedCount }"
                :disabled="!checkedCount"
                @click="sendWarehouse"
              >
                {{ $l('btn_sendWarehouse') || '通知送仓' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>
            <el-badge :value="checkedCount" class="ml-3" v-if="allow('B')">
              <b-button
                size="sm"
                variant="outline-primary"
                class="printer-button"
                :class="{ clearable: !!checkedCount }"
                @click="exportFile"
                :disabled="!checkedCount"
              >
                {{ $l('INDEX.btn_export') || '导出' }}
                <i
                  class="el-icon-circle-close"
                  @click.stop="clearCheckboxRow"
                />
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="140px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_amzFtyNoticeOutStatus') || '状态'"
            >
              <el-checkbox-group v-model="form.listAmzFtyNoticeOutStatus">
                <el-checkbox label="N">
                  {{ $l('form_label_amzFtyNoticeOutStatus_N') || '新增' }}
                </el-checkbox>
                <el-checkbox label="S">
                  {{ $l('form_label_amzFtyNoticeOutStatus_S') || '已通知' }}
                </el-checkbox>
                <el-checkbox label="F">
                  {{ $l('form_label_amzFtyNoticeOutStatus_F') || '已确认' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_amzFtyNoticeOutStatus_Y') || '已出库' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('form_label_amzFtyNoticeOutStatus_D') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amzFtyNoticeOutNo') || '通知书编号'"
            >
              <el-input
                v-model.trim="form.amzFtyNoticeOutNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_shipmentByFactory') || '是否工厂发货'"
            >
              <el-select
                v-model="form.listShipmentByFactory"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
                style="width: 100%;"
              >
                <el-option
                  value="Y"
                  :label="$l('form_label_shipmentByFactory_y') || '是'"
                >
                </el-option>
                <el-option
                  value="N"
                  :label="$l('form_label_shipmentByFactory_n') || '否'"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_ecomWarehouse') || '出库仓库'">
              <dict-select
                v-model="form.listEcomWarehouseCode"
                url="/ecom/warehouse/cn/warehouse/select"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm') || '供应商'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_amazonStoreRegion') || '店铺区域'"
            >
              <dict-select
                v-model="form.listAmazonStoreRegion"
                url="/ecom/amz/market/dictSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_shipPlanType') || '发运类型'">
              <dict-select
                v-model="form.listShipPlanType"
                url="/master/common/dict/biz"
                :body="shipPlanTypeParams"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_buyer') || '跟单业务'">
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_bookContractNo') || '外运编号'"
            >
              <el-input
                v-model.trim="form.bookContractNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_cust') || '下单客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_endCust') || '终端客户'">
              <dict-select
                v-model="form.listEndCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                multiple
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_deliveryDate') || '预约日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_comfirmDeliveryDate') || '确认送仓日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.comfirmDeliveryDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.comfirmDeliveryDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.table_label_created_date') || '创建时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.form_label_modification_time') || '修改时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  listAmzFtyNoticeOutStatus: ['N', 'S', 'F', 'Y'],
}
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      templateGroup: 'ecom-outboundNoticeBatch',
      shipPlanTypeParams: { dictType: 'shipPlanType' },
    }
  },
  props: { checkedCount: { type: Number, default: 0 } },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    exportFile() {
      this.$emit('exportFile', this.templateGroup)
    },
    sendWarehouse() {
      this.$emit('sendWarehouse')
    },
    clearCheckboxRow() {
      this.$emit('clearCheckboxRow')
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}

.printer-button {
  .el-icon-circle-close {
    display: none;
  }
}
.printer-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
